import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { InactivityLogoutService } from '../inactivity-logout.service';
import { CommonService } from '../common.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-inactivity-warning-modal',
  templateUrl: './inactivity-warning-modal.component.html',
  styleUrls: ['./inactivity-warning-modal.component.scss']
})
export class InactivityWarningModalComponent implements OnInit, OnDestroy {
  showModal = false;
  secondsRemaining = 0;
  private warningSubscription?: Subscription;
  private logoutSubscription?: Subscription;

  constructor(
    private inactivityService: InactivityLogoutService,
    private router: Router,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    // Only subscribe to events if user is logged in
    if (!this.commonService.isLoggedIn()) {
      return;
    }

    // Subscribe to warning events
    this.warningSubscription = this.inactivityService.onWarning.subscribe((seconds: number) => {
      // Only show modal if user is still logged in
      if (!this.commonService.isLoggedIn()) {
        this.showModal = false;
        return;
      }

      if (seconds > 0) {
        this.secondsRemaining = seconds;
        this.showModal = true;
      } else {
        this.showModal = false;
      }
    });

    // Subscribe to logout events
    this.logoutSubscription = this.inactivityService.onLogout.subscribe(() => {
      this.showModal = false;
      // Only navigate if user was logged in
      if (this.commonService.isLoggedIn()) {
        window.location.href = '/';
      }
    });
  }

  ngOnDestroy(): void {
    if (this.warningSubscription) {
      this.warningSubscription.unsubscribe();
    }
    if (this.logoutSubscription) {
      this.logoutSubscription.unsubscribe();
    }
  }

  /**
   * User clicked "Stay Logged In" - reset the timer
   */
  stayLoggedIn(): void {
    // Only reset timer if user is logged in
    if (!this.commonService.isLoggedIn()) {
      this.showModal = false;
      return;
    }

    this.inactivityService.resetTimer();
    this.showModal = false;
  }

  /**
   * Format seconds to MM:SS
   */
  formatTime(seconds: number): string {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }
}


